module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "批量域迁移",
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "batchMigrateInfo",
    attrs: {
      "model": _vm.batchMigrateInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "域名",
      "prop": "namespacesArray"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, _vm._l((_vm.batchMigrateInfo.namespacesArray), function(item) {
    return _c('el-tag', {
      key: item,
      staticClass: "form-tags",
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "目标集群",
      "prop": "zkClusterKeyNew"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "size": "small"
    },
    model: {
      value: (_vm.batchMigrateInfo.zkClusterKeyNew),
      callback: function($$v) {
        _vm.$set(_vm.batchMigrateInfo, "zkClusterKeyNew", $$v)
      },
      expression: "batchMigrateInfo.zkClusterKeyNew"
    }
  }, _vm._l((_vm.onLineClusters), function(item) {
    return _c('el-option', {
      key: item.zkClusterKey,
      attrs: {
        "label": item.zkAlias,
        "value": item.zkClusterKey
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d22ad18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/batch_migrate_dialog.vue
// module id = 1381
// module chunks = 1